'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { ButtonIcon } from '../ui/button-icon';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-center gap-4 md:w-fit',
        'ea-category-sort',
        className,
      )}
    >
      <Paragraph className="hidden font-semibold md:block" size="sm" color="muted-foreground">
        Zobraziť podľa
      </Paragraph>
      <div className={cn('w-full sm:w-fit', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={`Zobraziť podľa: ${t(VALUES.find(option => String(option.value) === selectedValue)?.label ?? 'text341')}`}
            // placeholder={`${t('text341')}..`}
            innerTriggerClassName="px-6 md:px-4 gap-2"
            className={cn(
              'h-[52px] w-full gap-6 rounded-full border border-border bg-transparent md:w-fit',
              'ea-category-sort__select-trigger',
            )}
            expandIcon={null}
          >
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('', 'ea-category-sort__select-value')}
            />
            <ButtonIcon alt={t('text2076')} url="/images/icons/arrow-down-primary.svg" />
          </SelectTrigger>
          <SelectContent
            sideOffset={2}
            className={cn(
              'rounded-[12px] border border-border shadow-none',
              'ea-category-sort__select-content',
            )}
          >
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
